import * as actionTypes from '../actions/actionTypes';

const initialState = {
    value:1000
};

const rangeBarReducer = ( state = initialState, action ) => {
    switch ( action.type ) {
        case actionTypes.GET_RANGEBAR_VALUE : return {...state, value:action.payLoad }
        default:
            return state;
    }
};

export default rangeBarReducer;


/** WEBPACK FOOTER **
 ** ./src/store/reducer/rangeBarReducer.js
 **/